import HttpClient from "../HttpClient";
import RazorpayPayment from "../interfaces/razorpayPayment";

export default class DiscountCouponExtensionService {
    async getDiscountCouponExtensionDetails(extensionRequestId: number) {
        const res = await HttpClient.get(`/centaurus/discount-coupon-order/expiry-extension-requests/${extensionRequestId}`);
        if (res?.status === 200) {
            return res?.data;
        }
        return null;
    }

    async initiatePayment(extensionRequestId: number): Promise<any> {
        const res = await HttpClient.post(`/customers/discount-coupon-order/expiry-extension-request/${extensionRequestId}/razorpay-order`);
        return res?.data;
    }

    async updatePaymentStatus(transactionId: number, data: RazorpayPayment) {
        const res = await HttpClient.patch(`/customers/discount-coupon-order/expiry-extension-request/${transactionId}/razorpay-order`, data);
        return res?.data;
    }
}
